import React from "react";

// Measures a scroll box's live top offset and returns a max-height that fills the
// rest of the viewport (minus `bottomGap`), so the box can scroll internally while
// everything above it stays fixed. Measured (not a magic number), so it adapts to
// whatever markup sits above the box. Recomputes on window resize + a deferred
// post-paint pass. Returns null while disabled / before the first measure.
//   ref        — ref to the scroll-box element
//   enabled    — turn the behaviour on (default true)
//   bottomGap  — px reserved below the box (page-nav + bottom padding). Tunable.
export function useFitViewportHeight(ref, { enabled = true, bottomGap = 72 } = {}) {
  const [maxH, setMaxH] = React.useState(null);
  React.useEffect(
    function () {
      if (!enabled) return;
      function recalc() {
        const el = ref.current;
        if (!el) return;
        const top = el.getBoundingClientRect().top;
        setMaxH(Math.max(220, Math.round(window.innerHeight - top - bottomGap)));
      }
      recalc();
      const raf = requestAnimationFrame(recalc);
      window.addEventListener("resize", recalc);
      return function () {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", recalc);
      };
    },
    [ref, enabled, bottomGap]
  );
  return maxH;
}
